var _rect, _g, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eTIgB3ovct51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 30,
    rx: 5,
    ry: 5,
    transform: "translate(25 31.705301)",
    fill: "#fff",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0-1 300.000031 473.4106)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230.13382,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "matrix(1.021145 0 0 1 25 226.705301)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 15,
    rx: 5,
    ry: 5,
    transform: "matrix(.707107 0.707107-.707107 0.707107 241.644661 201.233847)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 15,
    rx: 5,
    ry: 5,
    transform: "matrix(.707107-.707107 0.707107 0.707107 231.038059 261.570153)",
    fill: "#fff",
    strokeWidth: 0
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 30,
    rx: 5,
    ry: 5,
    transform: "translate(75 96.705301)",
    fill: "#fff",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 30,
    rx: 5,
    ry: 5,
    transform: "translate(125 161.705301)",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClose);
export default __webpack_public_path__ + "static/media/sidebar-close.3032ca01e6ef1be5258fcdbfbd1c795e.svg";
export { ForwardRef as ReactComponent };